import styled, { css } from 'styled-components';
import _isNumber from 'lodash/isNumber';
import { media } from '@minecraft.themes';
import SelectableSearchDropdown from '@minecraft.selectable-search-dropdown';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';
import FormikCheckbox from '@minecraft.formik-checkbox';
import FormikDatePicker from '@minecraft.formik-date-picker';
import Checkbox from '@minecraft.checkbox';

export const DropdownStyles = css`
  // Need to override the default property
  button {
    height: auto;
  }
  .dropdown-menu {
    width: 100%;
  }
`;

export const FormItem = styled.div<{ $fullWidth?: boolean; $marginValue?: number }>`
  margin-bottom: ${(props) => (_isNumber(props.$marginValue) ? props.$marginValue : 1)}rem;

  ${(props) =>
    !props.$fullWidth &&
    `
    max-width: 18.75rem;
  `}
`;

export const BasicFormItem = styled.div`
  margin-bottom: 1rem;

  ${media.sm`
    margin: 0;
  `}
`;

export const FieldWrapper = styled.div`
  background-color: ${(props): string => props.theme.form.backgroundColor};
  border: 1px solid ${(props): string => props.theme.form.borderColor};
  border-radius: 0.25rem;
  padding: 0.4375rem 0.5rem;
`;

export const FieldGroup = styled.div`
  align-items: center;
  display: flex;
`;

export const FieldGroupItem = styled.div`
  &:not(:last-child) {
    margin-right: 1rem;
  }
`;

export const Delimiter = styled.div`
  font-size: 0.875rem;
  margin: 0 0.5rem;
`;

export const Label = styled.label<{ $asHint?: boolean; $noMargin?: boolean; $subLabel?: string }>`
  font-size: 1rem;
  font-weight: 600;

  ${(props) =>
    !props.$noMargin &&
    `
    margin-bottom: 0.5rem;
  `}
  color: ${(props): string => props.theme.form.labelColor};

  &:after {
    content: ${(props): string => (props.$subLabel ? `"${props.$subLabel}"` : 'none')};
    display: block;
    font-size: 0.75rem;
    font-style: ${(props): string => (props.$asHint ? 'italic' : 'normal')};
    font-weight: normal;
  }
`;

export const StyledSelectableSearchDropdown = styled(SelectableSearchDropdown)`
  ${DropdownStyles}
`;

export const StyledFormikSelectableSearchDropdown = styled(FormikSelectableSearchDropdown)`
  ${DropdownStyles}
`;

export const StyledFormikSimpleCheckbox = styled(FormikSimpleCheckbox)`
  margin: 0;
`;

export const StyledFormikCheckbox = styled(FormikCheckbox)`
  margin: 0;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
`;

export const StyledFormikDatePicker = styled(FormikDatePicker)`
  .react-datepicker-wrapper {
    div > button {
      top: 0;
      right: 0;
    }

    input {
      padding-top: 0.125rem;
      padding-bottom: 0.125rem;
      height: 2rem;
      width: 100%;
    }
  }

  svg {
    flex-shrink: 0;
  }
  .react-datepicker-popper {
    z-index: 999;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  margin-top: 0.75rem;
`;

export const ClearButton = styled.div`
  color: ${(props): string => props.theme.colors.buttons.primary.default};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  margin-right: 0.25rem;

  &:hover {
    color: ${(props): string => props.theme.colors.buttons.primary.hover};
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: column;

  ${media.md`
    flex-direction: row;
  `}
`;

export const Column = styled.div<{ $columnsAmount?: number }>`
  &:not(:last-child) {
    padding-right: 2rem;
  }

  ${media.md`
  ${(props) =>
    props.$columnsAmount > 0 &&
    `
  width: calc(100% / ${props.$columnsAmount});
`}
  `}
`;
